const texts = {
    "return-items-exchange-product-no-items": {
        EN: "There are no available item variants to exchange to",
        DA: "Der er ingen tilgængelige varevarianter at bytte til",
        DE: "Es gibt keine verfügbaren Artikelvarianten zum Austauschen",
        NL: "Er zijn geen beschikbare artikelvarianten om naar te ruilen",
        FR: "Il n'y a pas de variantes d'articles disponibles pour l'échange",
        IT: "Non ci sono varianti di articoli disponibili per lo scambio",
        ES: "No hay variantes de artículos disponibles para intercambiar",
        PT: "Não há variantes de itens disponíveis para troca",
        FI: "Ei vaihtokelpoisia tuoteversioita saatavilla",
        SV: "Det finns inga varianter att byta till för den här varan",
        NO: "Det er ingen alternativer å bytte til for denne varen",
    },
    "return-items-exchange-free-shipping-intro": {
        EN: "Get free shipping by choosing a returned product!",
        DA: "Få gratis fragt ved at vælge et returneret produkt!",
        DE: "Erhalten Sie kostenlosen Versand, indem Sie ein zurückgegebenes Produkt wählen!",
        NL: "Krijg gratis verzending door een geretourneerd product te kiezen!",
        FR: "Obtenez la livraison gratuite en choisissant un produit retourné!",
        IT: "Ottieni la spedizione gratuita scegliendo un prodotto restituito!",
        ES: "¡Obtén envío gratis eligiendo un producto devuelto!",
        PT: "Obtenha frete grátis escolhendo um produto devolvido!",
        FI: "Saat ilmaisen toimituksen valitsemalla palautetun tuotteen!",
        SV: "Få gratis frakt genom att välja en returnerad produkt!",
        NO: "Få gratis frakt ved å velge et returnert produkt!",
    },
    "return-items-exchange-free-shipping-outro": {
        EN: "This product will be sent directly from another customer, saving approximately b{1200 km} in unnecessary transport",
        DA: "Dette produkt sendes direkte fra en anden kunde, hvilket sparer ca. b{1200 km} i unødvendig transport",
        DE: "Dieses Produkt wird direkt von einem anderen Kunden gesendet und spart ungefähr b{1200 km} unnötigen Transport",
        NL: "Dit product wordt direct verzonden van een andere klant, wat ongeveer b{1200 km} aan onnodige transport bespaart",
        FR: "Ce produit sera envoyé directement d'un autre client, économisant environ b{1200 km} de transport inutile",
        IT: "Questo prodotto verrà inviato direttamente da un altro cliente, risparmiando circa b{1200 km} di trasporto non necessario",
        ES: "Este producto se enviará directamente desde otro cliente, ahorrando aproximadamente b{1200 km} en transporte innecesario",
        PT: "Este produto será enviado diretamente de outro cliente, economizando aproximadamente b{1200 km} em transporte desnecessário",
        FI: "Tämä tuote lähetetään suoraan toiselta asiakkaalta, säästäen noin b{1200 km} turhaa kuljetusta",
        SV: "Denna produkt skickas direkt från en annan kund och sparar cirka b{1200 km} onödig transport",
        NO: "Dette produktet vil bli sendt direkte fra en annen kunde, og sparer ca b{1200 km} i unødvendig transport",
    },
    "return-items-exchange-free-shipping": {
        EN: "Free shipping",
        DA: "Gratis fragt",
        DE: "Kostenloser Versand",
        NL: "Gratis verzending",
        FR: "Livraison gratuite",
        IT: "Spedizione gratuita",
        ES: "Envío gratis",
        PT: "Frete grátis",
        FI: "Ilmainen toimitus",
        SV: "Gratis frakt",
        NO: "Gratis frakt",
    },
    "return-items-exchange-free-shipping-returned-product": {
        EN: "Returned product",
        DA: "Returneret produkt",
        DE: "Zurückgegebenes Produkt",
        NL: "Geretourneerd product",
        FR: "Produit retourné",
        IT: "Prodotto restituito",
        ES: "Producto devuelto",
        PT: "Produto devolvido",
        FI: "Palautettu tuote",
        SV: "Returnerad produkt",
        NO: "Returnert produkt",
    },
    "return-items-exchange-shipping-cost": {
        EN: "59 kr shipping",
        DA: "59 kr fragt",
        DE: "59 kr Versand",
        NL: "59 kr verzending",
        FR: "59 kr livraison",
        IT: "59 kr spedizione",
        ES: "59 kr envío",
        PT: "59 kr envio",
        FI: "59 kr toimitus",
        SV: "59 kr fraktkostnad",
        NO: "59 kr frakt",
    },
    "return-items-exchange-store-product": {
        EN: "Store product",
        DA: "Butiksprodukt",
        DE: "Ladenprodukt",
        NL: "Winkelproduct",
        FR: "Produit en magasin",
        IT: "Prodotto del negozio",
        ES: "Producto de tienda",
        PT: "Produto da loja",
        FI: "Kaupan tuote",
        SV: "Butiksprodukt",
        NO: "Butikkprodukt",
    },
    "return-items-exchange-invalid-input": {
        EN: "Please select more properties",
        DA: "Vælg venligst flere egenskaber",
        DE: "Bitte wählen Sie mehr Eigenschaften aus",
        NL: "Selecteer meer eigenschappen",
        FR: "Veuillez sélectionner plus de propriétés",
        IT: "Seleziona più proprietà",
        ES: "Por favor selecciona más propiedades",
        PT: "Por favor selecione mais propriedades",
        FI: "Valitse lisää ominaisuuksia",
        SV: "Vänligen välj fler alternativ",
        NO: "Vennligst velg flere alternativer",
    },
    "return-items-exchange-invalid-at-least-one": {
        EN: "Please select at least one property",
        DA: "Vælg venligst mindst én egenskab",
        DE: "Bitte wählen Sie mindestens eine Eigenschaft aus",
        NL: "Selecteer ten minste één eigenschap",
        FR: "Veuillez sélectionner au moins une propriété",
        IT: "Seleziona almeno una proprietà",
        ES: "Por favor selecciona al menos una propiedad",
        PT: "Por favor selecione pelo menos uma propriedade",
        FI: "Valitse vähintään yksi ominaisuus",
        SV: "Vänligen välj minst ett alternativ",
        NO: "Vennligst velg minst ett alternativ",
    },
    "return-items-return-select-one": {
        EN: "Please select at least one reason",
        DA: "Vælg venligst mindst én grund",
        DE: "Bitte wählen Sie mindestens einen Grund aus",
        NL: "Selecteer ten minste één reden",
        FR: "Veuillez sélectionner au moins une raison",
        IT: "Seleziona almeno un motivo",
        ES: "Por favor selecciona al menos una razón",
        PT: "Por favor selecione pelo menos um motivo",
        FI: "Valitse vähintään yksi syy",
        SV: "Vänligen välj minst en anledning",
        NO: "Vennligst velg minst én grunn",
    },
    "return-items-exchange-product-has-no-variants": {
        EN: "This product has no available alternatives. Please select another one",
        DA: "Dette produkt har ingen tilgængelige alternativer. Vælg venligst et andet",
        DE: "Dieses Produkt hat keine verfügbaren Alternativen. Bitte wählen Sie ein anderes",
        NL: "Dit product heeft geen beschikbare alternatieven. Selecteer een ander",
        FR: "Ce produit n'a pas d'alternatives disponibles. Veuillez en sélectionner un autre",
        IT: "Questo prodotto non ha alternative disponibili. Selezionane un altro",
        ES: "Este producto no tiene alternativas disponibles. Por favor selecciona otro",
        PT: "Este produto não tem alternativas disponíveis. Por favor selecione outro",
        FI: "Tällä tuotteella ei ole saatavilla olevia vaihtoehtoja. Valitse toinen",
        SV: "Denna produkt har inga tillgängliga alternativ. Vänligen välj en annan",
        NO: "Dette produktet har ingen tilgjengelige alternativer. Vennligst velg en annen",
    },
    "return-items-resale-upload-image": {
        EN: "You need to successfully upload an image",
        DA: "Du skal uploade et billede",
        DE: "Sie müssen ein Bild erfolgreich hochladen",
        NL: "Je moet een afbeelding uploaden",
        FR: "Vous devez télécharger une image avec succès",
        IT: "Devi caricare un'immagine con successo",
        ES: "Necesitas subir una imagen exitosamente",
        PT: "Você precisa carregar uma imagem com sucesso",
        FI: "Sinun täytyy ladata kuva onnistuneesti",
        SV: "Vänligen ladda upp en bild",
        NO: "Vennligst last opp et bilde",
    },
    "product-recommendation": {
        EN: "Here are some similar products that you might find interesting",
        DA: "Her er nogle lignende produkter, som du måske finder interessante",
        DE: "Hier sind einige ähnliche Produkte, die Sie interessant finden könnten",
        NL: "Hier zijn enkele vergelijkbare producten die je misschien interessant vindt",
        FR: "Voici quelques produits similaires qui pourraient vous intéresser",
        IT: "Ecco alcuni prodotti simili che potresti trovare interessanti",
        ES: "Aquí hay algunos productos similares que podrían interesarte",
        PT: "Aqui estão alguns produtos similares que você pode achar interessantes",
        FI: "Tässä on samanlaisia tuotteita jotka saattavat kiinnostaa sinua",
        SV: "Varför inte byta? Bläddra bland liknande produkter för att hitta rätt alternativ",
        NO: "Hvorfor ikke bytte? Bla gjennom lignende varer for å finne riktig alternativ",
    },
    "compare-btn": {
        EN: "Click to compare",
        DA: "Klik for at sammenligne",
        DE: "Zum Vergleichen klicken",
        NL: "Klik om te vergelijken",
        FR: "Cliquez pour comparer",
        IT: "Clicca per confrontare",
        ES: "Haz clic para comparar",
        PT: "Clique para comparar",
        FI: "Klikkaa vertaillaksesi",
        SV: "Klicka för att jämföra",
        NO: "Klikk for å sammenligne",
    },
    "compare-tooltip": {
        EN: "Compare with the item you're returning",
        DA: "Sammenlign med den vare du returnerer",
        DE: "Vergleichen Sie mit dem Artikel, den Sie zurückgeben",
        NL: "Vergelijk met het item dat je retourneert",
        FR: "Comparez avec l'article que vous retournez",
        IT: "Confronta con l'articolo che stai restituendo",
        ES: "Compara con el artículo que estás devolviendo",
        PT: "Compare com o item que você está devolvendo",
        FI: "Vertaa tuotteeseen jota olet palauttamassa",
        SV: "Jämför med den produkt du returnerar",
        NO: "Sammenlign med varen du returnerer",
        EN_TR: "Compare with the product you're returning",
    },
    "exchange-select-button": {
        EN: "Select",
        DA: "Vælg",
        DE: "Auswählen",
        NL: "Selecteer",
        FR: "Sélectionner",
        IT: "Seleziona",
        ES: "Seleccionar",
        PT: "Selecionar",
        FI: "Valitse",
        SV: "Välj",
        NO: "Velg",
    },
};
export default texts;
